import { useState, useEffect, useMemo, useCallback } from 'react';
import { get, find } from 'lodash-es';
import { getLocale } from 'umi';
import { getStreamingkOLFiltersData } from '@/pages/intelligence/services/filter';
import { IOptions } from '../page';

export default function useFilterOptions() {
  const [headQuatersOptionsData, setHeadQuatersOptionsData] = useState<any[]>(
    [],
  );
  const [regionsOptions, setRegionsOptions] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const {
        data: { language, country },
      } = await getStreamingkOLFiltersData();
      const languages = Object.keys(language).map((task) => ({
        text: language[task],
        value: task,
      }));
      const countrys = Object.keys(country).map((task) => ({
        text: country[task],
        value: task,
      }));
      setHeadQuatersOptionsData(languages);
      setRegionsOptions(countrys);
    })();
  }, []);

  return {
    headQuatersOptionsData,
    regionsOptions,
  };
}

export const useOptionslistSegment = <T extends string>(
  value?: T,
  titleKeys?: T,
) => {
  const locale = getLocale();
  const optionslist: IOptions[] = [
    {
      text: locale === 'zh-CN' ? '观看时长(小时)' : 'Hours Watched(hours)',
      value: 'hoursWatched',
    },
    {
      text: locale === 'zh-CN' ? '直播观众峰值' : 'Peak CCV',
      value: 'peackCCV',
    },
    {
      text: locale === 'zh-CN' ? '直播观众平均值' : 'Avg CCV',
      value: 'avgCCV',
    },
    { text: locale === 'zh-CN' ? '直播时长(小时)' : 'Airtime(hours)', value: 'airtime' },
  ];
  const findStreamKeyHoversFn = useCallback(
    (itemValues?: string) =>
      get(find(optionslist, { value: itemValues?.toString() }), 'text', ''),
    [optionslist, value, locale],
  ) as Function;

  const hoverBubbleText = useMemo(
    () => findStreamKeyHoversFn(value),
    [optionslist, value, locale],
  );

  const titleText = useMemo(() => {
    const sorts = titleKeys?.split('_') as string[];
    const keys = findStreamKeyHoversFn(sorts?.[0]);
    if (sorts?.length > 1) {
      return keys + '(%)';
    }
    return keys;
  }, [optionslist, value, locale]);
  return [optionslist, hoverBubbleText, titleText];
};
